import {
    Component,
    OnInit,
    ElementRef,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    HostBinding,
    ViewChild,
    inject,
    input,
    output,
    computed,
    Signal,
} from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, combineLatest, Observable, of, withLatestFrom } from 'rxjs';
import { debounceTime, map, tap } from 'rxjs/operators';

interface DatapickerViewConfig {
    typeHeadCalendar?: 'left' | 'center';
    typeSelectMonth?: 'list' | 'grid';
    iconLeft?: string;
    iconRight?: string;
    valueMonthWithComma?: boolean;
    typeValueMonth?: 'short' | 'long';
}

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --widthOne: initial; --gap-calendar: 0; --width: calc(var(--bazis-calendar-number, 1) * var(--widthOne) + var(--gap-calendar)); --background: initial; --box-shadow: initial; --border-radius-datepicker: initial; --padding-start: initial; --padding-end: initial; --padding-top: initial; --padding-bottom: initial; --font-weight: inherit; --font-family: inherit; --font-size: inherit; --color: initial; --font-size-head: inherit; --font-weight-head: var(--font-weight); --color-head: var(--color); --icon-size-head: 24px; --font-size-weekday: inherit; --font-weight-weekday: var(--font-weight-day); --color-weekday: var(--color); --text-transform-weekday: uppercase; --width-day: auto; --height-day: auto; --gap-days: initial; --gap-week: initial; --border-radius-day: initial; --border-width-day: initial; --border-style-day: initial; --border-color-day: initial; --border-width-day-hover: var(--border-width-day); --border-style-day-hover: var(--border-style-day); --border-color-day-hover: var(--border-color-day); --border-width-day-focus: var(--border-width-day); --border-style-day-focus: var(--border-style-day); --border-color-day-focus: var(--border-color-day); --border-width-day-selected: var(--border-width-day); --border-style-day-selected: var(--border-style-day); --border-color-day-selected: var(--border-color-day); --border-width-day-selected-hover: var(--border-width-day-hover); --border-style-day-selected-hover: var(--border-style-day-hover); --border-color-day-selected-hover: var(--border-color-day-hover); --border-width-day-selected-focus: var(--border-width-day-focus); --border-style-day-selected-focus: var(--border-style-day-focus); --border-color-day-selected-focus: var(--border-color-day-focus); --border-width-day-current: var(--border-width-day); --border-style-day-current: var(--border-style-day); --border-color-day-current: var(--border-color-day); --border-width-day-current-hover: var(--border-width-day-hover); --border-style-day-current-hover: var(--border-style-day-hover); --border-color-day-current-hover: var(--border-color-day-hover); --border-width-day-current-focus: var(--border-width-day-focus); --border-style-day-current-focus: var(--border-style-day-focus); --border-color-day-current-focus: var(--border-color-day-focus); --border-width-day-muted: var(--border-width-day); --border-style-day-muted: var(--border-style-day); --border-color-day-muted: var(--border-color-day); --border-width-day-interval: var(--border-width-day); --border-style-day-interval: var(--border-style-day); --border-color-day-interval: var(--border-color-day); --border-width-day-interval-hover: var(--border-width-day-hover); --border-style-day-interval-hover: var(--border-style-day-hover); --border-color-day-interval-hover: var(--border-color-day-hover); --border-width-day-interval-focus: var(--border-width-day-focus); --border-style-day-interval-focus: var(--border-style-day-focus); --border-color-day-interval-focus: var(--border-color-day-focus); --background-hover: var(--background); --background-focus: var(--background); --background-selected: var(--background); --background-selected-hover: var(--background); --background-selected-focus: var(--background); --background-current: var(--background); --background-current-hover: var(--background); --background-current-focus: var(--background); --background-muted: var(--background); --background-interval: var(--background-hover); --opacity-day: initial; --font-weight-day: inherit; --font-weight-day-selected: var(--font-weight-day); --color-hover: var(--color); --color-focus: var(--color); --color-selected: var(--color); --color-selected-hover: var(--color-selected); --color-selected-focus: var(--color-selected); --color-current: var(--color); --color-current-hover: var(--color-current); --color-current-focus: var(--color-current); --color-muted: var(--color); --color-interval: var(--color-hover); --interval-start-end-border-radius: var(--border-radius-day); --weekend-background: var(--background); --weekend-background-hover: var(--background-hover); --weekend-background-focus: var(--background-focus); --weekend-color: var(--color); --weekend-color-hover: var(--color-hover); --weekend-color-focus: var(--color-focus); --gap-month: initial; --background-month: initial; --color-month: var(--color); --mark-background-confirmed: initial; --mark-background-unconfirmed: initial; --mark-background-other: initial; } :host .bazis-list { list-style: none; padding: 0; margin: 0; user-select: none; } :host .bazis-list .bazis-item { cursor: pointer; color: var(--color); } :host .bazis-list .bazis-item--selected { background: var(--background-selected); color: var(--color-selected); } :host .bazis-list .bazis-item:hover { background: var(--background-hover); color: var(--color-hover); } :host .bazis-list .bazis-item--disabled { opacity: 0.5; pointer-events: none; } .bazis-datepicker { box-sizing: border-box; display: flex; gap: var(--gap-calendar); position: relative; width: var(--width, 180px); margin: auto; background: var(--background, #fff); box-shadow: var(--box-shadow, 0px 0px 25px rgba(0, 0, 0, 0.1)); border-radius: var(--border-radius-datepicker); padding-left: var(--padding-start); padding-right: var(--padding-end); padding-top: var(--padding-top); padding-bottom: var(--padding-bottom); font-family: var(--font-weight); font-family: var(--font-family); font-size: var(--font-size); color: var(--color); } .bazis-datepicker__backdrop { position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 0; } .bazis-calendar { position: relative; width: 100%; user-select: none; } .bazis-calendar__btn { cursor: pointer; } .bazis-calendar__btn:disabled { cursor: default; pointer-events: none; } .bazis-calendar__head { display: flex; justify-content: space-between; align-items: center; padding: 0 var(--bazis-padding-3x); height: 24px; } .bazis-calendar__head .bazis-calendar__value { display: flex; align-items: center; font-size: var(--font-size-head); font-weight: var(--font-weight-head); color: var(--color-head); } .bazis-calendar__head_left .bazis-calendar__btn { margin-left: var(--bazis-margin-4x); } .bazis-calendar__head_left .bazis-calendar__head__buttons { display: flex; } .bazis-calendar__body { display: flex; justify-content: center; } .bazis-calendar__foot .bazis-btn-group { display: flex; justify-content: space-between; } .bazis-calendar__foot .bazis-btn-group .bazis-calendar__btn { width: auto; } .bazis-calendar__table { width: 100%; border-collapse: collapse; } .bazis-calendar__table td, .bazis-calendar__table th { min-width: var(--width-day); height: var(--height-day); padding: 0; line-height: var(--height-day); } .bazis-calendar__table tr { display: flex; gap: var(--gap-days); justify-content: space-between; align-items: center; width: 100%; } .bazis-calendar__table tbody { display: flex; flex-direction: column; align-items: center; gap: var(--gap-week); } .bazis-calendar__grid { display: grid; grid-template-columns: repeat(3, 1fr); width: 100%; gap: var(--gap-month); text-align: center; } .bazis-calendar__grid .bazis-item { background: var(--background-month); color: var(--color-month); } .bazis-calendar__weekday { text-transform: var(--text-transform-weekday); font-weight: var(--font-weight-weekday); font-size: var(--font-size-weekday); color: var(--color-weekday); } .bazis-calendar__day { box-sizing: border-box; position: relative; border-radius: var(--border-radius-day); border-width: var(--border-width-day); border-style: var(--border-style-day); border-color: var(--border-color-day); cursor: pointer; text-align: center; font-weight: var(--font-weight-day); } .bazis-calendar__day_weekend { background: var(--weekend-background); color: var(--weekend-color); } .bazis-calendar__day_current { background: var(--background-current); border-width: var(--border-width-day-current); border-style: var(--border-style-day-current); border-color: var(--border-color-day-current); color: var(--color-current); } .bazis-calendar__day_interval { position: relative; border-radius: 0; border-width: var(--border-width-day-interval); border-style: var(--border-style-day-interval); border-color: var(--border-color-day-interval); background: var(--background-interval); color: var(--color-interval); --border-radius: 0; } .bazis-calendar__day_interval::before { content: ""; position: absolute; right: 100%; height: 100%; width: var(--gap-days); background: var(--background-interval); } .bazis-calendar__day_interval_first { border-top-right-radius: 0; border-bottom-right-radius: 0; } .bazis-calendar__day_interval_first:nth-child(7n) { border-top-right-radius: var(--interval-start-end-border-radius); border-bottom-right-radius: var(--interval-start-end-border-radius); } .bazis-calendar__day_interval_last::before { content: ""; position: absolute; right: 100%; height: 100%; width: var(--gap-days); background: var(--background-interval); } .bazis-calendar__day_interval_last + .bazis-calendar__day--selected { border-top-left-radius: 0; border-bottom-left-radius: 0; } .bazis-calendar__day_interval_last.bazis-calendar__day--selected { border-top-right-radius: var(--border-radius-day); border-bottom-right-radius: var(--border-radius-day); } .bazis-calendar__day_interval:nth-child(7n):not(.bazis-calendar__day--selected) { border-top-right-radius: var(--interval-start-end-border-radius); border-bottom-right-radius: var(--interval-start-end-border-radius); } .bazis-calendar__day_interval:nth-child(7n+1) { border-top-left-radius: var(--interval-start-end-border-radius); border-bottom-left-radius: var(--interval-start-end-border-radius); } .bazis-calendar__day_interval:nth-child(7n+1)::before { display: none; } .bazis-calendar__day_interval_first.bazis-calendar__day_interval_last { border-top-right-radius: var(--border-radius-day); border-bottom-right-radius: var(--border-radius-day); } .bazis-calendar__day_interval_first.bazis-calendar__day_interval_last::before { display: none; } .bazis-calendar__day--muted { background: var(--background-muted); border-width: var(--border-width-day-muted); border-style: var(--border-style-day-muted); border-color: var(--border-color-day-muted); color: var(--color-muted); opacity: var(--datepicker-muted-opacity, 0.3); pointer-events: none; } .bazis-calendar__day--selected { background: var(--background-selected); border-width: var(--border-width-day-selected); border-style: var(--border-style-day-selected); border-color: var(--border-color-day-selected); color: var(--color-selected); font-weight: var(--font-weight-day-selected); } .bazis-calendar__day:hover { background: var(--background-hover); border-width: var(--border-width-day-hover); border-style: var(--border-style-day-hover); border-color: var(--border-color-day-hover); color: var(--color-hover); } .bazis-calendar__day:active { background: var(--background-focus); border-width: var(--border-width-day-focus); border-style: var(--border-style-day-focus); border-color: var(--border-color-day-focus); color: var(--color-focus); } .bazis-calendar__day_weekend:hover { background: var(--weekend-background-hover); color: var(--weekend-color-hover); } .bazis-calendar__day_weekend:active { background: var(--weekend-background-focus); color: var(--weekend-color-focus); } .bazis-calendar__day_current:hover { background: var(--background-current-hover, var(--background-hover)); border-width: var(--border-width-day-current-hover); border-style: var(--border-style-day-current-hover); border-color: var(--border-color-day-current-hover); color: var(--color-current-hover); } .bazis-calendar__day_current:active { background: var(--background-current-focus, var(--background-focus)); border-width: var(--border-width-day-current-focus); border-style: var(--border-style-day-current-focus); border-color: var(--border-color-day-current-focus); color: var(--color-current-focus); } .bazis-calendar__day--selected:hover { background: var(--background-selected-hover, var(--background-hover)); border-width: var(--border-width-day-selected-hover); border-style: var(--border-style-day-selected-hover); border-color: var(--border-color-day-selected-hover); color: var(--color-selected-hover); } .bazis-calendar__day--selected:active { background: var(--background-selected-focus, var(--background-focus)); border-width: var(--border-width-day-selected-focus); border-style: var(--border-style-day-selected-focus); border-color: var(--border-color-day-selected-focus); color: var(--color-selected-focus); } .bazis-calendar__day__mark { position: absolute; } .bazis-calendar__day__mark--confirmed { background: var(--mark-background-confirmed); } .bazis-calendar__day__mark--unconfirmed { background: var(--mark-background-unconfirmed); } .bazis-calendar__day__mark--other { background: var(--mark-background-other); } .bazis-dropdown { position: relative; z-index: 1; } .bazis-dropdown__trigger { cursor: pointer; margin: 0 var(--bazis-margin-2x); line-height: 16px; } .bazis-dropdown__body { position: absolute; z-index: 1; top: 18px; left: 50%; transform: translateX(-50%); background: var(--background); border-radius: var(--bazis-border-radius); border: 1px solid var(--bazis-background-medium); box-shadow: 0px 4px 24px -10px rgba(0, 0, 0, 0.1); } .bazis-dropdown_hoverable:hover .bazis-dropdown__body { display: block; } bazis-button bazis-icon { font-size: var(--icon-size-head); } bazis-button.bazis-btn--hidden { visibility: hidden !important; }`,
);

@Component({
    selector: 'bazis-datepicker',
    templateUrl: './datepicker.component.html',
    // styleUrls: ['datepicker.component.scss'],
    host: {
        '(mouseleave)': 'this._onMouseLeave()',
    },
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DatepickerElement implements OnInit {
    public el = inject(ElementRef);

    readonly formatOutput = input<string>();

    readonly canToggleDay = input(true);

    readonly minDate = input<string>();

    readonly maxDate = input<string>();

    readonly resetBtn = input<{ use: boolean; txt?: string }>({ use: false });

    readonly currentDateBtn = input<{ use: boolean; txt?: string }>({ use: false });

    readonly additionalBtns = input<{ txt: string; clickFn: () => void }[]>([]);

    readonly calendarsNumber = input(1);

    readonly startYear = input<number>();

    readonly disabledIntervals = input<string[][]>([]);

    readonly visibleAllYears = input<boolean>(false);

    readonly viewConfig = input<DatapickerViewConfig>();

    readonly marks$ = input<Observable<{ [index: number]: string }>>();

    readonly value = input<Date[]>([null]);

    valueChange = output<any>();

    onMouseLeave = output<Date[]>();

    startCalendarChange = output<{
        year: number;
        month: number;
    }>();

    readonly currentMarks$: Signal<Observable<{ [index: number]: string } | null>> = computed(
        () => {
            return this.marks$() || of(null);
        },
    );

    @HostBinding('style.--bazis-calendar-number') get styleVarNumber() {
        return `${this.calendarsNumber()}`;
    }

    @ViewChild('listYear') set listYear(el: ElementRef) {
        if (!el) return;

        this.listYearEl = el.nativeElement;
        this.yearSelected = this.listYearEl.querySelector('#yearSelected');
    }

    defaultViewConfig: DatapickerViewConfig = {
        typeHeadCalendar: 'left',
        typeSelectMonth: 'list',
        iconLeft: 'angle-small-left',
        iconRight: 'angle-small-right',
        valueMonthWithComma: false,
        typeValueMonth: 'long',
    };

    allViewConfig: DatapickerViewConfig;

    listYearEl;

    yearSelected;

    private selectedValue = [null];

    public monthListOpened: number = null;

    public yearsListOpened: number = null;

    // TODO: make these $ props as signals, add computed signal calendars instead of observable; make marks$ not observable but ordinary signal;
    // After need to fix marks in agro go project (the only one where it's used)

    currentYear$ = new BehaviorSubject(moment().year());

    currentMonth$ = new BehaviorSubject(moment().month());

    selectedDay$ = new BehaviorSubject(null);

    selectedMonth$ = new BehaviorSubject(null);

    selectedYear$ = new BehaviorSubject(null);

    diffMonth$ = new BehaviorSubject(null);

    diffYear$ = new BehaviorSubject(null);

    calendars$: Observable<any[]>;

    updateMonth$ = this.diffMonth$.pipe(
        withLatestFrom(this.currentMonth$),
        tap(([diff, currentMonth]) => {
            if (!diff) return;
            let nextMonth = currentMonth + diff;
            if (nextMonth > 11) {
                nextMonth = 0;
                this.diffYear$.next(1);
            }
            if (nextMonth < 0) {
                nextMonth = 11;
                this.diffYear$.next(-1);
            }
            this.currentMonth$.next(nextMonth);
        }),
    );

    updateYear$ = this.diffYear$.pipe(
        withLatestFrom(this.currentYear$),
        tap(([diff, currentYear]) => {
            if (!diff) return;
            this.currentYear$.next(currentYear + diff);
        }),
    );

    updateStartCalendar$ = combineLatest([this.currentYear$, this.currentMonth$]).pipe(
        debounceTime(0),
        tap(([currentYear, currentMonth]) => {
            this.startCalendarChange.emit({
                year: currentYear,
                month: currentMonth + 1, // + 1 to receive in 1-12 format
            });
        }),
    );

    ngOnInit() {
        this.allViewConfig = {
            ...this.defaultViewConfig,
            ...this.viewConfig(),
        };

        const minDate = this.minDate();
        const maxDate = this.maxDate();
        this.selectedValue = this.value();
        if (this.selectedValue[0] !== null) {
            this.currentYear$.next(moment(this.selectedValue[0]).year());
            this.currentMonth$.next(moment(this.selectedValue[0]).month());
        } else if (this.selectedValue[1] && this.selectedValue[1] !== null) {
            let month = moment(this.selectedValue[1]).month() - this.calendarsNumber();
            let year = moment(this.selectedValue[1]).year();
            if (month < 0) {
                year--;
                month += 12;
            }
            this.currentYear$.next(year);
            this.currentMonth$.next(month);
        } else if (minDate) {
            this.currentYear$.next(moment(minDate).year());
            this.currentMonth$.next(moment(minDate).month());
        } else if (maxDate && moment(maxDate).isBefore(moment())) {
            this.currentYear$.next(moment(maxDate).year());
            this.currentMonth$.next(moment(maxDate).month());
        } else {
            this.currentYear$.next(moment().year());
            this.currentMonth$.next(moment().month());
        }
        this.buildCalendar();

        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }

    buildCalendar() {
        this.calendars$ = combineLatest([
            this.currentYear$,
            this.currentMonth$,
            this.selectedDay$,
            this.selectedMonth$,
            this.selectedYear$,
            this.currentMarks$(),
        ]).pipe(
            debounceTime(10),
            map(([currentYear, currentMonth, selectedDay, selectedMonth, selectedYear, marks]) => {
                const calendars = [];

                for (let i = 0; i < this.calendarsNumber(); i++) {
                    let calendarMonth = (currentMonth + i) % 12;
                    let calendarYear = currentYear + Math.floor((currentMonth + i) / 12);

                    const monthList = this.monthNames.map((monthName, index) => {
                        return {
                            id: index,
                            name: monthName,
                            isCurrent: calendarMonth === index,
                            isMuted: this.isMutedMonth(calendarYear, index),
                        };
                    });
                    const yearList = this.getYearsList(calendarYear).map((year) => {
                        return {
                            id: year,
                            isCurrent: year === calendarYear,
                            isMuted: this.isMutedYear(calendarMonth, year),
                        };
                    });
                    const tmpDate = moment().month(calendarMonth).year(calendarYear);
                    const endDateOfMonth = tmpDate.endOf('month').date();
                    const daysMatrix = [1, 2, 3, 4, 5, 6].map((row, rowIndex) => {
                        return this.weekDaysNamesShort.map((col, colIndex) => {
                            const dayNumber = this.calculateShowingDay(
                                calendarYear,
                                calendarMonth,
                                rowIndex,
                                colIndex,
                            );

                            return {
                                dayNumber,
                                isValid: dayNumber > 0 && dayNumber <= endDateOfMonth,
                                isToday: this.isTodayDay(calendarYear, calendarMonth, dayNumber),
                                isSelected: this.isSelectedDay(
                                    calendarYear,
                                    calendarMonth,
                                    dayNumber,
                                ),
                                isMuted: this.isMutedDay(calendarYear, calendarMonth, dayNumber),
                                isInInterval: this.isDayInInterval(
                                    calendarYear,
                                    calendarMonth,
                                    dayNumber,
                                ),
                                isInIntervalLast: this.isDayInIntervalLast(
                                    calendarYear,
                                    calendarMonth,
                                    dayNumber,
                                ),
                                isInIntervalFirst: this.isDayInIntervalFirst(
                                    calendarYear,
                                    calendarMonth,
                                    dayNumber,
                                ),
                                mark: this.getDayMark(
                                    calendarYear,
                                    calendarMonth,
                                    dayNumber,
                                    marks,
                                ),
                                isWeekend: this.isWeekendDay(
                                    calendarYear,
                                    calendarMonth,
                                    dayNumber,
                                ),
                            };
                        });
                    });

                    calendars.push({
                        isFirst: i === 0,
                        isLast: i === this.calendarsNumber() - 1,
                        calendarYear,
                        calendarMonth,
                        selectedDay,
                        selectedMonth,
                        selectedYear,
                        monthList,
                        yearList,
                        daysMatrix,
                        disabledPrevYear: this.isMutedYear(calendarMonth, calendarYear - 1),
                        disabledNextYear: this.isMutedYear(calendarMonth, calendarYear + 1),
                        //disabledPrevMonth: this.isMutedMonth(calendarYear, calendarMonth - 1),
                        //disabledNextMonth: this.isMutedMonth(calendarYear, calendarMonth + 1),
                        disabledPrevMonth: false, // есть моменты, когда стрелочки в две стороны дизейблены и весь месяц в дизейбле тоже и неясно, что делать. Поэтому стрелки пока будут всегда enable
                        disabledNextMonth: false,
                    });
                }
                return calendars;
            }),
        );
    }

    _onMouseLeave() {
        this.onMouseLeave.emit(this.selectedValue);
    }

    clear() {
        this.selectedValue = this.selectedValue.map((v) => null);
    }

    weekDaysNamesShort: Array<string> = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

    monthNames: Array<string> = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ];

    getYearsList(currentYear): number[] {
        const firstYear = this.getStartYear(currentYear);
        const years = [];
        if (this.visibleAllYears()) {
            const maxDate = this.maxDate();
            const endYear = maxDate ? moment(maxDate).year() : moment().add(20, 'y').year();
            for (let i = firstYear; i <= endYear; i++) years.push(i);
        } else {
            for (let i = firstYear; i < currentYear + 20; i++) years.push(i);
        }
        return years;
    }

    getStartDay(currentYear, currentMonth): number {
        const tmpDate = new Date(currentYear, currentMonth, 1);
        return -this.correctWeekDay(moment(tmpDate).day()) + 1;
    }

    getStartYear(currentYear): number {
        const startYear = this.startYear();
        if (startYear) return startYear;

        return currentYear - 4;
    }

    isTodayDay(currentYear, currentMonth, day: number): boolean {
        return (
            currentYear == moment().year() &&
            currentMonth == moment().month() &&
            day == moment().date()
        );
    }

    isSelectedDay(currentYear, currentMonth, day: number): boolean {
        return (
            this.selectedValue.findIndex(
                (valueItem) =>
                    currentYear === moment(valueItem).year() &&
                    currentMonth === moment(valueItem).month() &&
                    day === moment(valueItem).date(),
            ) > -1
        );
    }

    isMutedDay(currentYear, currentMonth, day: number): boolean {
        const currentDate = new Date(currentYear, currentMonth, day);

        const minDate = this.minDate();
        const maxDate = this.maxDate();
        const basicMute =
            (minDate && new Date(minDate) >= new Date(currentYear, currentMonth, day + 1)) ||
            (maxDate && new Date(maxDate) < currentDate);

        const disabledIntervals = this.disabledIntervals();
        if (basicMute || !disabledIntervals || disabledIntervals.length === 0) return basicMute;
        return (
            disabledIntervals.findIndex(
                (interval) =>
                    currentDate >= new Date(interval[0] + 'T00:00:00.0000') &&
                    currentDate <= new Date(interval[1] + 'T00:00:00.0000'),
            ) > -1
        );
    }

    isDayInInterval(currentYear, currentMonth, day: number): boolean {
        if (this.selectedValue.length === 1 || !this.selectedValue[1] || !this.selectedValue[0])
            return false;
        const tmpDate: Date = new Date(currentYear, currentMonth, day);
        return this.selectedValue[0] < tmpDate && this.selectedValue[1] > tmpDate;
    }

    isDayInIntervalLast(currentYear, currentMonth, day: number): boolean {
        if (this.selectedValue.length === 1 || !this.selectedValue[1] || !this.selectedValue[0])
            return false;
        const tmpDate: Date = new Date(currentYear, currentMonth, day);
        return moment(this.selectedValue[1]).isSame(moment(tmpDate), 'date');
    }

    isDayInIntervalFirst(currentYear, currentMonth, day: number): boolean {
        if (this.selectedValue.length === 1 || !this.selectedValue[1] || !this.selectedValue[0])
            return false;
        const tmpDate: Date = new Date(currentYear, currentMonth, day);
        return moment(this.selectedValue[0]).isSame(moment(tmpDate), 'date');
    }

    isWeekendDay(currentYear, currentMonth, day: number): boolean {
        const currentDate = new Date(currentYear, currentMonth, day);
        return moment(currentDate).day() === 6 || moment(currentDate).day() === 0;
    }

    getDayMark(currentYear, currentMonth, day: number, marks): string {
        if (!marks) return null;
        const tmpDate: Date = new Date(currentYear, currentMonth, day);
        return marks[tmpDate.getTime()];
    }

    isMutedMonth(currentYear, month: number) {
        const minDateValue = this.minDate();
        const maxDateValue = this.maxDate();
        if (!minDateValue && !maxDateValue) return false;
        const currentDate: Date = new Date(currentYear, month);
        if (minDateValue) {
            let minDate = new Date(minDateValue);
            minDate = new Date(moment(minDate).year(), moment(minDate).month());
            if (minDate > currentDate) return true;
        }
        if (maxDateValue) {
            let maxDate = new Date(maxDateValue);
            maxDate = new Date(moment(maxDate).year(), moment(maxDate).month());
            if (maxDate < currentDate) return true;
        }

        return false;
    }

    isMutedYear(currentMonth, year: number) {
        const currentDate: Date = new Date(year, currentMonth);
        const minDate = this.minDate();
        const maxDate = this.maxDate();
        return (
            (minDate && moment(minDate).year() > moment(currentDate).year()) ||
            (maxDate && moment(maxDate).year() < moment(currentDate).year())
        );
    }

    calculateShowingDay(currentYear, currentMonth, row: number, col: number): number {
        return row * 7 + col + this.getStartDay(currentYear, currentMonth);
    }

    validatingMinMaxDate(dates: Date[]): Date[] {
        const minDate: Date = new Date(this.minDate());
        const maxDate: Date = new Date(this.maxDate());
        const minDateValue = this.minDate();
        if (dates[0] && minDateValue && moment(dates[0]).isBefore(moment(minDateValue), 'days')) {
            dates[0] = minDate;
        }
        const maxDateValue = this.maxDate();
        if (
            maxDateValue &&
            dates[dates.length - 1] &&
            moment(dates[dates.length - 1]).isAfter(moment(maxDateValue), 'days')
        ) {
            dates[dates.length - 1] = maxDate;
        }
        return dates;
    }

    correctWeekDay(weekDay: number): number {
        if (weekDay == 0) weekDay = 7; // поправим воскресенье
        return weekDay - 1;
    }

    selectTodayDay() {
        this.selectedValue[0] = new Date();
        this.currentMonth$.next(moment(this.selectedValue[0]).month());
        this.currentYear$.next(moment(this.selectedValue[0]).year()); // getUTCFullYear
        if (this.formatOutput()) {
            this.valueChange.emit(
                this.selectedValue.map((v) => moment(v).format(this.formatOutput())),
            );
        } else {
            this.valueChange.emit(this.selectedValue);
        }
    }

    handleDayClick(day, currentYear, currentMonth) {
        if (day.isSelected) {
            if (!this.canToggleDay()) return;
            else {
                this.selectedValue = [];
                this.changeDate();
                return;
            }
        }
        this.changeDay(day.dayNumber, currentYear, currentMonth);
    }

    changeDate() {
        this.selectedValue = this.validatingMinMaxDate(this.selectedValue);

        if (this.formatOutput()) {
            this.valueChange.emit(
                this.selectedValue.map((v) => moment(v).format(this.formatOutput())),
            );
        } else {
            this.valueChange.emit(this.selectedValue);
        }

        this.selectedDay$.next(moment(this.selectedValue[0]).date().toString());
        this.selectedMonth$.next(this.monthNames[moment(this.selectedValue[0]).month()]);
        this.selectedYear$.next(moment(this.selectedValue[0]).year().toString());
    }

    changeDay(selectedDay: number, currentYear, currentMonth) {
        const newValue = moment().set({
            year: currentYear,
            month: currentMonth,
            date: selectedDay,
            hour: 0,
            minute: 0,
        });
        const newValueDate = newValue.toDate();
        if (this.selectedValue.length === 1) {
            this.selectedValue = [newValueDate];
        } else {
            if (
                (this.selectedValue[1] &&
                    this.selectedValue[0] &&
                    this.selectedValue[1].valueOf() !== this.selectedValue[0].valueOf()) ||
                (!this.selectedValue[1] && !this.selectedValue[0])
            ) {
                this.selectedValue = [newValueDate, newValueDate];
            } else if (
                !this.selectedValue[1] ||
                this.selectedValue[1].valueOf() === this.selectedValue[0].valueOf()
            ) {
                if (moment(this.selectedValue[0]).isAfter(newValue)) {
                    this.selectedValue[1] = this.selectedValue[0];
                    this.selectedValue[0] = newValueDate;
                } else {
                    this.selectedValue[1] = newValueDate;
                }
            } else {
                if (moment(this.selectedValue[1]).isBefore(newValue)) {
                    this.selectedValue[0] = this.selectedValue[1];
                    this.selectedValue[1] = newValueDate;
                } else {
                    this.selectedValue[0] = newValueDate;
                }
            }
        }

        this.changeDate();
    }

    changeCurrentMonth(month) {
        if (!month.isMuted) this.currentMonth$.next(month.id);
    }

    changeCurrentYear(year: number) {
        this.currentYear$.next(year);
        this.yearSelected = this.listYearEl.querySelector('#yearSelected');
    }

    stepNextMonth() {
        this.diffMonth$.next(1);
    }

    stepPrevMonth() {
        this.diffMonth$.next(-1);
    }

    stepNextYear() {
        this.diffYear$.next(1);
    }

    stepPrevYear() {
        this.diffYear$.next(-1);
    }

    public toogleMonthList(calendarIndex) {
        this.monthListOpened = this.monthListOpened === calendarIndex ? null : calendarIndex;
        this.yearsListOpened = null;
    }

    public toogleYearsList(calendarIndex) {
        if (this.yearsListOpened === calendarIndex) {
            this.yearsListOpened = null;
        } else {
            this.yearsListOpened = calendarIndex;

            setTimeout(() => {
                if (this.yearSelected) this.yearSelected.scrollIntoView();
            }, 0);
        }
        this.monthListOpened = null;
    }

    public closeLists() {
        this.yearsListOpened = null;
        this.monthListOpened = null;
    }
}
